import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { Account } from '../../models/AccountModel';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { GridSpinnerComponent } from 'src/app/shared/grid-spinner.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ScanResult } from 'src/app/models/ScanResultModel';
import { ScanTarget } from 'src/app/models/ScanTargetModel';
import { SettingsWizardComponent } from '../settings-wizard/settings-wizard-dialog.component';
import { AutomateScanTargetListComponent } from 'src/app/secured/scanner/automate-scan-target-list.component';

@Component({
  selector: 'app-device-vulnerability-scan-dashboard',
  templateUrl: './device-vulnerability-scan-dashboard.component.html',
  styleUrls: ['./device-vulnerability-scan-dashboard.component.scss']
})
export class DeviceVulnerabilityScanDashboardComponent implements OnInit {
  state;
  selectedScan:ScanResult;
  selectedTarget: ScanTarget;
  selectedScanResult: ScanResult;
  showAllDevices;

  @Input() account:Account;
  @Input() subAccount:Account;
  @ViewChild('spinner', { static: true }) spinner: GridSpinnerComponent;
  @ViewChild(AutomateScanTargetListComponent) targetsList: AutomateScanTargetListComponent;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _platformApi: PlatformApiService, private _themeManager: ThemeManagerService, public _sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
    if (!this.account) {
      this.account = this._sessionService.getCurrentAccount();
    }

    this.showAllDevices = (this._activatedRoute.snapshot.data.showAllDevices === true) ? true : false
    this._activatedRoute.params.subscribe(params => {
      console.log('DeviceVulnerabilityScanDashboardComponent:ngOnInit:route', this._activatedRoute.routeConfig.path, params);
      const requestedScanTargetId = params.scanTargetId;
      const requestedScanResultId = params.scanResultId;

      if (requestedScanTargetId) {
        const subAcctId = this.subAccount ? this.subAccount.id : undefined;
        this._platformApi.getScanTarget(this.account.id, subAcctId, requestedScanTargetId).subscribe(st => {
          this.selectedTarget = st;

          if (requestedScanResultId) {
            this._platformApi.getScanTargetResult(this.account.id, subAcctId, this.selectedTarget.id, requestedScanResultId).subscribe(sr => {
              this.selectedScanResult = sr;
              this.state = 'TARGET_RESULT_SUMMARY';
            });
          } else {
            this.state = 'TARGET_RESULTS_LIST';
          }
        });
      } else {
        this.state = 'LIST';
      }
    });

    console.log('DeviceVulnerabilityScanDashboardComponent.ngOnInit:account', this.account);
  }

  getParentAccount() {
    return this.subAccount !== undefined ? this.account : undefined;
  }

  getWorkingAccount() {
    return this.subAccount !== undefined ? this.subAccount : this.account;
  }

  showAllScanTargets() {
    console.log('DeviceVulnerabilityScanDashboardComponent:showList:route', 'vulnerabilityScans/scanTargets', {relativeTo:this._activatedRoute.parent});
    this._router.navigate(['vulnerabilityScans/scanTargets'], {relativeTo:this._activatedRoute.parent});
  }

  showScanTarget() {
    console.log('DeviceVulnerabilityScanDashboardComponent:showScanTarget:route', `vulnerabilityScans/scanTargets/${this.selectedTarget.id}/scanResults`, {relativeTo:this._activatedRoute.parent});
    this._router.navigate([`vulnerabilityScans/scanTargets/${this.selectedTarget.id}/scanResults`], {relativeTo:this._activatedRoute.parent});
  }

  onStateChange(event) {
    console.log('DeviceVulnerabilityScanDashboardComponent.onStateChange:event', event);

    switch(event.state) {
      case 'SELECT_SCAN_TARGET':
        this._router.navigate([`vulnerabilityScans/scanTargets/${event.item.id}/scanResults`], {relativeTo: this._activatedRoute.parent});
        break;
      case 'SELECT_SCAN_TARGET_RESULT':
        this._router.navigate([`vulnerabilityScans/scanTargets/${this.selectedTarget.id}/scanResults/${event.item.id}`], {relativeTo: this._activatedRoute.parent});
        break;
      case 'ACCOUNT_AUTOMATE_INTEGRATE':
         const currentAccount = this._sessionService.getCurrentAccount()
         let dialogRef;
          dialogRef = this.dialog.open(SettingsWizardComponent, {
            panelClass: 'flush-dialog',
            disableClose: true,
            autoFocus: false,
            data: {
              selectedAccount: currentAccount,
              startingMenuItem: 'ACCOUNT_AUTOMATE_INTEGRATE'
            }
          });
          dialogRef.afterClosed().subscribe(() => {
             this.targetsList.refresh();
          });
        break;
      default:
        this.showAllScanTargets();
        break;
    }
  }
}
